function drawToBlob(bitmap, maxDim, quality) {
  let { width, height } = bitmap;
  if (Math.max(width, height) > maxDim) {
    const scale = maxDim / Math.max(width, height);
    width = Math.round(width * scale);
    height = Math.round(height * scale);
  }
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d").drawImage(bitmap, 0, 0, width, height);
  return new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", quality));
}

export async function compressImage(file, maxDim = 1920, quality = 0.8) {
  if (!file.type.startsWith("image/")) return file;
  let bitmap;
  try {
    bitmap = await createImageBitmap(file);
    const blob = await drawToBlob(bitmap, maxDim, quality);
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  } finally {
    // ImageBitmap holds a large native (non-heap) buffer that regular GC
    // doesn't reliably reclaim promptly -- across a batch of many large photos
    // this is what was silently exhausting memory and stalling the upload.
    bitmap?.close?.();
  }
}

// Produces several resized variants (e.g. full + thumbnail) from a single
// decode instead of decoding the same source image once per variant -- halves
// the peak memory for the common "full + thumb" case.
export async function compressImageVariants(file, variants) {
  if (!file.type.startsWith("image/")) return variants.map(() => file);
  let bitmap;
  try {
    bitmap = await createImageBitmap(file);
    const blobs = await Promise.all(variants.map((v) => drawToBlob(bitmap, v.maxDim, v.quality)));
    return blobs.map((blob) => (blob ? new File([blob], file.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" }) : file));
  } catch {
    return variants.map(() => file);
  } finally {
    bitmap?.close?.();
  }
}
